<template>
  <div class="c-header-visual" :class="classes">
    <div class="__slot" v-show="false"><slot /></div>
    <div class="c-header-visual__content"
      v-if="src"
      v-background="src"
    >
      <div class="c-header-visual__title" v-if="title">{{title}}</div>
    </div>
  </div>
</template>


<script>

import u from "../lib/u.js";

export default {
  props: ["modifier"],

  data (){
    return {
      state: false,
      src: null,
      title: null,
    }
  },

  computed: {
    classes (){
      let value = this.state ? ["-active"] : [];
      if(this.modifier){
        value.push(this.modifier);
      }
      return value.join(" ");
    }
  },

  directives: {
    background (el, o){
      el.style.backgroundImage = `url(${o.value})`;
    }
  },

  mounted (){
    const img = this.$el.querySelector(".__slot img");
    const src = u.parseSrcset(img);

    this.title = u.exists(this.$el.querySelector(".__slot .title"), "innerText");


    setTimeout(() => {
      if(img){
        this.src = src;
        this.state = true;
      }
    }, 100)
  }

}
</script>



// WEBPACK FOOTER //
// src/component/header-visual.vue